import { LoginLogo } from "@/features/auth/components/LoginLogo";
import { RecoverForm } from "@/features/auth/components/RecoverForm";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";

type TRecoverPageProps = {};

export const RecoverPage: FC<TRecoverPageProps> = () => {
  return (
    <Stack gap={4} alignItems="center">
      <LoginLogo />
      <Typography variant="head20Bold" marginTop={2}>
        パスワード再発行
      </Typography>
      <Typography variant="body14" width={"100%"}>
        登録されたメールアドレスを入力してください。
      </Typography>
      <RecoverForm />
    </Stack>
  );
};
